/**
 * @generated SignedSource<<c45af118e70bf500a63ef63d3e04caf1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type recoilGetProviderInfoQuery$variables = {
  provider_id: number;
};
export type recoilGetProviderInfoQuery$data = {
  readonly sys_providers: ReadonlyArray<{
    readonly ingestion_config: any | null;
    readonly organization: {
      readonly settings: any | null;
    } | null;
    readonly provider_id: number;
    readonly provider_name: string;
    readonly provider_type_id: number;
  }>;
};
export type recoilGetProviderInfoQuery = {
  response: recoilGetProviderInfoQuery$data;
  variables: recoilGetProviderInfoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "provider_id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "provider_id"
              }
            ],
            "kind": "ObjectValue",
            "name": "provider_id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_providers",
    "kind": "LinkedField",
    "name": "sys_providers",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider_name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider_id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider_type_id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ingestion_config",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "sys_organizations",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "settings",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "recoilGetProviderInfoQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "recoilGetProviderInfoQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "007aedb143a885d8a9a904a183d2423a",
    "id": null,
    "metadata": {},
    "name": "recoilGetProviderInfoQuery",
    "operationKind": "query",
    "text": "query recoilGetProviderInfoQuery(\n  $provider_id: Int!\n) {\n  sys_providers(where: {provider_id: {_eq: $provider_id}}) {\n    provider_name\n    provider_id\n    provider_type_id\n    ingestion_config\n    organization {\n      settings\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4c03502c251fb47919ac4a1eb4223a06";

export default node;
